import { ActionButton, ToggleSwitch } from "../../../helper/ImageFormat";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useEffect, useRef } from "react";
const PageTable = ({
 loading,
 contentData,
 currentPage,
 perPage,
 totalPages,
 totalCount,
 handlePageClick,
 handleOnDragEnd,
 handleStatusToggle,
 handleEditClick,
 handleDelete,
 selected,
 setSelected,
}) => {

  const selectAllRef = useRef(null);
  const isAllSelected =
  contentData.length > 0 && selected.length === contentData.length;
 const isIndeterminate =
  selected.length > 0 && selected.length < contentData.length;

  
   useEffect(() => {
    if (selectAllRef.current) {
     selectAllRef.current.indeterminate = isIndeterminate;
    }
   }, [isIndeterminate]);
  
   const toggleSelectAll = () => {
    setSelected(isAllSelected ? [] : contentData.map((b) => b.id));
   };
  
   const toggleSelectOne = (id) => {
    setSelected((prev) =>
     prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
   };

 return (
  <>
   <DragDropContext onDragEnd={handleOnDragEnd}>
    <Droppable droppableId="sliders">
     {(provided) => (
      <div
       {...provided.droppableProps}
       ref={provided.innerRef}
       className="table-responsive"
      >
       <table className="custom-table table table-striped" cellSpacing="0">
        <thead>
         <tr>
           <th>
           <input
            type="checkbox"
            ref={selectAllRef}
            checked={isAllSelected}
            onChange={toggleSelectAll}
           />
          </th>

          <th>Position</th>
          <th>Title</th>
          <th>Page Name</th>
          <th>Type</th>
          <th>Active</th>
          <th>Action</th>
         </tr>
        </thead>
        <tbody>
         {loading ? (
          <tr>
           <td colSpan="8" className="text-center">
            <Spinner />
           </td>
          </tr>
         ) : contentData.length > 0 ? (
          contentData.map((item, index) => (
           <Draggable
            key={item.id}
            draggableId={item.id.toString()}
            index={index}
           >
            {(provided) => (
             <tr
              className="text-center"
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
             >
               <td>
             <input
              type="checkbox"
              checked={selected.includes(item.id)}
              onChange={() => toggleSelectOne(item?.id)}
             />
            </td>
             <td className="text-left">
               <span className="item-name">{item?.position}</span>
              </td>
              <td className="text-left">
               <span className="item-name">{item?.title}</span>
              </td>
 <td className="text-left">
               <span className="item-name">{item?.pageName}</span>
              </td>
              <td>
               <span className="badge badge-danger">{item?.type}</span>
              </td>

             

              <td className="text-left">
               <ToggleSwitch
                data={item}
                name="isActive"
                checked={item?.isActive}
                handleStatusToggle={handleStatusToggle}
                module={"Page Content"}
               />
              </td>

              <td className="text-left">
               <ActionButton
                data={item}
                handleEditClick={handleEditClick}
                handleDelete={handleDelete}
                module={"Page Content"}
               />
              </td>
             </tr>
            )}
           </Draggable>
          ))
         ) : (
          <tr>
           <td colSpan="8" className="text-center">
            <h4>No data available</h4>
           </td>
          </tr>
         )}
         {provided.placeholder}
        </tbody>
       </table>
      </div>
     )}
    </Droppable>
   </DragDropContext>

   {contentData.length > 0 && (
    <CustomPagination
     currentPage={currentPage}
     totalPages={totalPages}
     onPageChange={handlePageClick}
     perPage={perPage}
     totalCount={totalCount}
    />
   )}
  </>
 );
};

export default PageTable;
